import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

/** Legacy `/user-setting` URL — forwards to System Preferences with the same query params. */
@Component({
  selector: 'app-user-setting',
  standalone: true,
  template: '',
})
export class UserSettingComponent implements OnInit {
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);

  ngOnInit(): void {
    void this.router.navigate(['/system-preferences'], {
      queryParams: this.route.snapshot.queryParams,
      replaceUrl: true,
    });
  }
}
